// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"46384cc4","1538":"b461f413","4013":"aa764da4","4394":"d32f8bac","8071":"db7acac7"}[chunkId] + ".chunk.css";
};